import React, { useEffect } from "react";
import Title from "../../new-components/title/Title";
import {
  Link,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import Overllay from "../../assets/new_imgs/Rectangle 1072.png";
import NewFooter from "../../NewFooter";
import "./FoodAndBeverages.scss";
import NewLoader from "../../new-components/title/Loader/NewLoader";
import { ShowRoomDining } from "../../API/In-Room-DiningAPI";
import { useTranslation } from "react-i18next";

const InRoomDining = () => {
  const params = useParams();
  const [searchParams] = useSearchParams();
  const isDineIn = searchParams.get("source") === "dine-in";
  const { t } = useTranslation();
  const languages = JSON.parse(localStorage.getItem("languages"));
  const lang = localStorage.getItem("lang");
  const navigate = useNavigate();
  let restaurants;
  let menu;
  let text;

  const { data, isLoading } = ShowRoomDining(params.room_uuid, lang);
  if (!isLoading) {
    if (data.data.status === false) {
      navigate(`/${params.room_uuid}/qr-scan`);
    } else {
      menu = data.data.data;
      console.log(menu, "menu");
      restaurants = menu?.restaurants;
      text = menu?.center_header;

      if (restaurants?.length === 1) {
        // Auto-navigating makes the restaurant page the first page the guest
        // sees, so no `fromRestaurantsList` flag is sent: its header shows the
        // language select instead of a back button.
        navigate(
          isDineIn
            ? `/${restaurants[0].room_uuid}/rstauran-menu-categories/${restaurants[0].uuid}`
            : `/${params.room_uuid}/food-and-beverages/in-room-dining/${restaurants[0].uuid}`,
          { replace: true, state: { room_uuid: restaurants[0].room_uuid } },
        );
      }
    }
  }
  if (!isLoading) {
  }
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
    });
  }, []);

  return (
    <div className={`food pb-5 ${lang === "AR" && "arabic"}`}>
      {isLoading ? (
        <NewLoader />
      ) : (
        <>
          <Title
            title={isDineIn ? t("Restaurants") : text}
            isDineIn={isDineIn}
            languages={languages}
            disableTitleNav={isDineIn}
            hideIcon={isDineIn}
          />

          <div className="box_food">
            {restaurants?.length > 1 &&
              restaurants?.map((item, idx) => {
                return (
                  <div
                    className={`${
                      item.is_closed ? "closed restaurant-option" : ""
                    }`}
                  >
                    <Link
                      key={idx}
                      to={
                        isDineIn
                          ? `/${item.room_uuid}/rstauran-menu-categories/${item.uuid}`
                          : `/${params.room_uuid}/food-and-beverages/in-room-dining/${item.uuid}`
                      }
                      state={{
                        room_uuid: item.room_uuid,
                        fromRestaurantsList: true,
                      }}
                    >
                      <div className="closed-tag"></div>
                      {item?.is_closed && (
                        <span className="open_at">
                          {item.opens_at
                            ? `Opens at ${item.opens_at}`
                            : `Closed`}
                        </span>
                      )}
                      <img src={item?.image} alt="" className="booking_img" />
                      <img src={Overllay} alt="" className="overlay" />
                      <div className="text_food">
                        <h5 className="">
                          {lang === "EN" ? item.display_name : item.name}
                        </h5>
                        <p>
                          {item?.cuisines?.map((cuisine, idx) => {
                            if (idx + 1 < item?.cuisines.length) {
                              return `${cuisine.name}  |  `;
                            } else {
                              return `${cuisine.name}  `;
                            }
                          })}
                        </p>
                      </div>{" "}
                    </Link>
                  </div>
                );
              })}
          </div>
          {!isDineIn && <NewFooter />}
        </>
      )}
    </div>
  );
};

export default InRoomDining;
